define((require) => {
    "use strict";

    var AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView"),
        Backbone                      = require("backbone"),
        {Logger}                      = require("shared/util/Logger"),
        LoggedIn                      = require("shared/security/LoggedIn"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        template                      = require("ui/experience/widgets/embedWidget/EmbedWidgetPropertiesView.tpl"),
        UrlUtil                       = require("shared/util/UrlUtil"),
        AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    const EXPAND_PROPERTY = "embedExpanded";

    /**
     * The properties view for an embed widget.
     *
     * @class EmbedWidgetPropertiesView
     * @constructor
     *
     * @cfg {EmbedWidgetModel} model The model for the embed widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("EmbedWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template: template,

        // A bit of helper info for verbose and/or ad logins...
        templateHelpers: function() {
            return {
                descriptor: Logger.level() >= Logger.VERBOSE && LoggedIn.internal() ? UrlUtil.getUrlDescriptor(this.model.get("url")) : {type: "url"}
            };
        },

        ui: {
            embedProperties: ".embed-properties-accordion"
        },

        events: {
            "click .help-block .embedded": function() { // only present on valid embedded url descriptor
                var descriptor = UrlUtil.getUrlDescriptor(this.model.get("url"));
                Backbone.history.navigate("#" + descriptor.type + "/" + descriptor.id + "/edit/" + descriptor.scene, true);
            }
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties"
        },

        bindings: {
            ".url": "url"
        },

        _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || !this.model.hasUrl();
        },

        onRender: function() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({model: this.model, hideRotation: true, widgetView: this.options.widgetView}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/embedWidget/EmbedWidgetPropertiesView.js